import moment from "moment";
import * as XLSX from "xlsx";

import { Button } from "@/components/ui/button";
import { InputDateGroup } from "@/components/ui/input";
import { exportPRTMapping, fetchApi, getAuthCustomer } from "@/helpers/h";
import { useData } from "@/stores/data";
import { useModal } from "@/stores/modal";
import { useState } from "react";

export default function ExportPRT() {
  const { close } = useModal();
  const { loading, setLoading } = useData();
  const [filter, setFilter] = useState({
    from: moment().startOf("week").format("YYYY-MM-DD"),
    to: moment().endOf("week").format("YYYY-MM-DD"),
  });

  const handleExport = async () => {
    setLoading(true);
    const res = await fetchApi({
      url: `/v2/part_request_ticket?${new URLSearchParams({
        date_from: filter?.from,
        date_to: filter?.to,
        customer_ids:
          getAuthCustomer().length > 0
            ? getAuthCustomer()
                .map((obj) => obj.id)
                .join(",")
            : "",
      })}`,
      method: "GET",
    });
    const excelData = exportPRTMapping(res?.data?.data || [], filter);

    // Convert to Excel
    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "PRT Data");

    // Generate filename
    const filename = `prt_${moment().format("hhmm_DDMMYYYY")}.xlsx`;

    // Download Excel file
    XLSX.writeFile(wb, filename);
    setLoading(false);
  };

  return (
    <div className="flex flex-col gap-[20px] bg-white rounded-[8px] md:rounded-[12px] lg:rounded-[16px] p-[24px] max-h-[90dvh] overflow-y-auto overflow-x-hidden">
      <h2 className="font-bold md:w-[500px] text-[24px]">Export PRT</h2>
      <InputDateGroup
        label="From"
        value={filter?.from}
        disabled={loading}
        onChange={(date) => {
          setFilter((prev) => ({
            ...prev,
            from: date,
          }));
        }}
      />
      <InputDateGroup
        label="To"
        value={filter?.to}
        disabled={loading}
        onChange={(date) => {
          setFilter((prev) => ({
            ...prev,
            to: date,
          }));
        }}
      />
      <div className="flex gap-2 flex-col md:flex-row gap-3 justify-end">
        <Button variant="gray" onClick={close} isLoading={loading}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleExport} isLoading={loading}>
          Export to Excel
        </Button>
      </div>
    </div>
  );
}
